import { ExAxios } from '@ExAxios';
import g from '@global';
import axios from 'axios';
/**
 * 获取机构列表
 * @param params{}
 * */
export const fetchOrganList = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/manage/organ/organ/findList`,
            {
                ...params,
            },
            {
                ...config,
            },
        ),
    );

/**
 * 获取机构列表
 * @param params{}
 * */
export const fetchOrganTree = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/sys/subsys/sysSubSystem/org/findList`,
            {
                ...params,
            },
            {
                ...config,
            },
        ),
    );

/**
 * 获取河道列表
 * @param params{}
 * */

export const fetchWaterList = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/disc/water/findList`,
            {
                params,
                ...config,
            },
        ),
    );

/**
 * 获取水体分类
 * @param params{}
 * */
export const fetchWaterClassify = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/disc/water/countWaterType`,
            {
                params,
                ...config,
            },
        ),
    );

/**
 * 获取举报渠道
 * @param params{}
 * */
export const fetchReportList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/complaint/countComplaintWay`,
            {
                params,
                ...config,
            },
        ),
    );

/**
 * 获取整改数据
 * @param params{type:}TD:国储土地 GC重大工程 SZ水质 DQ大气 TS投诉 QT其他
 * */
export const fetchRectifyCount = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/rectify/countRectifyInfo`, {
            params,
            ...config,
        }),
    );
